export function getTodayStr() {
  return new Date().toISOString().slice(0, 10);
}

export function getDateStr(date) {
  return new Date(date).toISOString().slice(0, 10);
}

export function getWeekDates(refDate = new Date()) {
  const out = [];
  const day = refDate.getDay() || 7; // 1=Mon..7=Sun
  const monday = new Date(refDate);
  monday.setDate(refDate.getDate() - (day - 1));
  for (let i = 0; i < 7; i++) {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    out.push(d.toISOString().slice(0, 10));
  }
  return out;
}

export function getMonthDates(year, month) {
  const out = [];
  const last = new Date(year, month + 1, 0).getDate();
  for (let i = 1; i <= last; i++) {
    out.push(new Date(year, month, i).toISOString().slice(0, 10));
  }
  return out;
}

export function daysBetween(a, b) {
  const ms = new Date(a).getTime() - new Date(b).getTime();
  return Math.round(ms / 86400000);
}

export function isToday(dateStr) {
  return dateStr === getTodayStr();
}

export function ageFromBirthDate(birthDateStr) {
  if (!birthDateStr || typeof birthDateStr !== 'string') return null;
  const parts = birthDateStr.slice(0, 10).split('-').map(Number);
  if (parts.length !== 3 || parts.some(isNaN)) return null;
  const [by, bm, bd] = parts;
  const today = new Date();
  const ty = today.getFullYear();
  const tm = today.getMonth() + 1; // 1-12
  const td = today.getDate();
  let age = ty - by;
  if (tm < bm || (tm === bm && td < bd)) age--;
  if (age < 0 || age > 150) return null;
  return age;
}

export function getMaxBirthDate() {
  // 2 years ago minimum
  const d = new Date();
  d.setFullYear(d.getFullYear() - 2);
  return d.toISOString().slice(0, 10);
}

export function getMinBirthDate() {
  // 18 years ago maximum
  const d = new Date();
  d.setFullYear(d.getFullYear() - 18);
  return d.toISOString().slice(0, 10);
}
